export default __webpack_public_path__ + "static/media/pro_pic_cherry_blossoms.61150b2c.jpg";